<template>
  <div class="payment-result-page">
    <div v-if="loading" class="result-card">
      <div class="result-icon loading"><span></span></div>
      <h1>İşlem kontrol ediliyor</h1>
      <p class="result-desc">Lütfen bekleyiniz...</p>
    </div>

    <div v-else-if="error" class="result-card failed">
      <div class="result-icon failed"><span>!</span></div>
      <h1>İşlem tamamlanamadı</h1>
      <p class="result-desc">{{ error }}</p>
      <div class="result-actions">
        <button class="btn primary" @click="goSiparisList">Sipariş Listesine Git</button>
        <button class="btn" @click="goSepet">Sepete Git</button>
      </div>
    </div>

    <div v-else class="result-card pending">
      <div class="result-icon pending">
        <svg viewBox="0 0 24 24" width="50" height="50" fill="none">
          <path d="M12 8v4l3 3" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
        </svg>
      </div>
      <h1>{{ mode === "open" ? "SipariÅŸ oluÅŸturuluyor" : "Ödeme Başarılı, sipariş oluşturuluyor" }}</h1>
      <p class="result-desc">Lütfen bekleyiniz...</p>
    </div>
  </div>
</template>

<script>
import db from "../../db";

export default {
  name: "SiparisTahsilatSonuc",
  data() {
    return {
      loading: true,
      error: "",
      mode: "",
      payment: null,
      draft: null
    };
  },

  created() {
    this.$store.setLoading([false, ""]);
    this.mode = String((this.$route && this.$route.query && this.$route.query.mode) || "").trim() || "card";
    this.init();
  },

  methods: {
    readDraft() {
      try {
        const raw = sessionStorage.getItem("siparis_draft");
        this.draft = raw ? JSON.parse(raw) : null;
      } catch (e) {
        this.draft = null;
      }
    },

    readPaymentResult() {
      try {
        const raw = sessionStorage.getItem("payment_result");
        const sessionPayload = raw ? JSON.parse(raw) : null;

        const q = (this.$route && this.$route.query) ? this.$route.query : {};
        const qOrderNo = String(q.orderNo || "").trim();

        // Session'daki kayÄ±t baÅŸka orderNo'ya aitse query'yi esas al.
        if (qOrderNo && sessionPayload && sessionPayload.orderNo && String(sessionPayload.orderNo).trim() !== qOrderNo) {
          this.payment = null;
        } else {
          this.payment = sessionPayload;
        }

        if (!this.payment || !this.payment.status) {
          const status = String(q.status || "").trim() || "3d_pending";
          const providerCode = String(q.provider || "").trim().toLowerCase();
          this.payment = {
            success: status === "paid",
            status: status,
            orderNo: qOrderNo,
            clientOrderReference: String(q.ref || "").trim(),
            provider: { code: providerCode, name: providerCode, type: "" },
            errorCode: String(q.errorCode || "").trim() || null,
            errorMessage: String(q.errorMessage || "").trim() || null
          };
        }
      } catch (e) {
        this.payment = null;
      }
    },

    async fetchServerPaymentIfNeeded() {
      try {
        const orderNo = this.payment && this.payment.orderNo ? String(this.payment.orderNo).trim() : "";
        if (!orderNo) return;

        const res = await this.$request.get("payment/result/" + encodeURIComponent(orderNo));
        const body = res && res.data ? res.data : res;
        const row = body && body.data ? body.data : body;
        if (!row) return;

        const dbStatus = String(row.status || "").trim();
        if (dbStatus) {
          this.payment.status = dbStatus;
          this.payment.success = dbStatus === "paid";
        }
        if (!this.payment.errorMessage || !String(this.payment.errorMessage).trim()) {
          this.payment.errorMessage = row.fail_message || this.payment.errorMessage || "";
        }
      } catch (e) { }
    },

    async init() {
      try {
        this.readDraft();

        if (!this.draft || !Array.isArray(this.draft.items) || !this.draft.items.length) {
          this.error = "SipariÅŸ taslaÄŸÄ± bulunamadÄ± (sepet boÅŸ olabilir).";
          return;
        }

        if (this.mode === "open") {
          const openKey = this.draft && this.draft.createdAt ? ("siparis_created_open_" + String(this.draft.createdAt)) : "";
          if (openKey && sessionStorage.getItem(openKey) === "1") {
            this.$router.replace({ path: "/siparis/sonuc" });
            return;
          }
          await this.createOrderAndGoResult({ paymentOrderNo: "", createdKey: openKey });
          return;
        }

        this.readPaymentResult();
        await this.fetchServerPaymentIfNeeded();

        const st = this.payment && this.payment.status ? String(this.payment.status).trim() : "";
        if (st !== "paid") {
          // BaÅŸarÄ±sÄ±z / beklemede => standart tahsilat sonuc akÄ±ÅŸÄ±na git
          this.$router.replace({ path: "/tahsilat/sonuc", query: (this.$route && this.$route.query) ? this.$route.query : {} });
          return;
        }

        const orderNo = this.payment && this.payment.orderNo ? String(this.payment.orderNo).trim() : "";

        // Idempotency: aynÄ± orderNo iÃ§in bir kez sipariÅŸ oluÅŸtur
        const createdKey = orderNo ? ("siparis_created_for_payment_" + orderNo) : "";
        if (createdKey && sessionStorage.getItem(createdKey) === "1") {
          this.$router.replace({ path: "/siparis/sonuc" });
          return;
        }

        await this.createOrderAndGoResult({ paymentOrderNo: orderNo, createdKey });
      } catch (e) {
        this.error = (e && e.message) ? e.message : "Beklenmeyen hata";
      } finally {
        this.loading = false;
      }
    },

    async createOrderAndGoResult({ paymentOrderNo, createdKey } = {}) {
      const storeCari = this.$store ? this.$store.aktifCari : null;
      const draftCari = this.draft && this.draft.cari ? this.draft.cari : null;
      const cari =
        (storeCari && storeCari.kod && storeCari.guid) ? storeCari :
        (draftCari && draftCari.kod && draftCari.guid) ? draftCari :
        null;
      if (!cari || !cari.kod || !cari.guid) {
        throw new Error("Aktif cari bulunamadı");
      }

      const hesap = this.$request.ayar();

      this.$store.setLoading([true, "Bekleyiniz"]);
      try {
        // Idempotency: createdKey set ise tekrar çalıştırma
        if (createdKey && sessionStorage.getItem(createdKey) === "1") {
          this.$store.setLoading([false, "Bekleyiniz"]);
          this.$router.replace({ path: "/siparis/sonuc" });
          return;
        }

        const obj = {
          odeme: "1",
          cKod: cari.kod,
          notu: this.draft.siparisNotu || "",
          id: paymentOrderNo || "0",
          depo: "",
          teslim: 0,
          entegrekodu: hesap.entegrekodu,
          ekler: hesap.iskonto + "#" + hesap.ekiskonto + "#" + hesap.kmail,
          satir: this.draft.items
        };

        const timeoutMs = 50000;
        const apiResult = await Promise.race([
          this.$request.post(hesap.program + "/sipekle", obj),
          new Promise((_, reject) => setTimeout(() => reject(new Error("Mikro sunucusuna ulaşılamadı (timeout)")), timeoutMs))
        ]);

        if (apiResult && apiResult.status == 300) {
          this.$store.setLoading([false, "Bekleyiniz"]);
          this.$router.push("/oturum");
          return;
        }

        const normalized = Array.isArray(apiResult)
          ? { success: apiResult, errors: [], okCount: apiResult.length, failCount: 0 }
          : {
              success: (apiResult && Array.isArray(apiResult.success)) ? apiResult.success : [],
              errors: (apiResult && Array.isArray(apiResult.errors)) ? apiResult.errors : [],
              okCount: (apiResult && typeof apiResult.okCount === "number") ? apiResult.okCount : 0,
              failCount: (apiResult && typeof apiResult.failCount === "number") ? apiResult.failCount : 0
            };

        const response = normalized.success || [];
        const errors = normalized.errors || [];

        const successGuids = [];
        for (const e of response) {
          if (e && e.status) successGuids.push(e.guid);
        }

        if (successGuids.length) {
          const yeniBasket = (cari.basket || []).filter((it) => !successGuids.includes(it.guid));
          await db.caris.update(cari.guid, { basket: yeniBasket });
          if (this.$store && this.$store.aktifCari && this.$store.aktifCari.guid === cari.guid) {
            this.$store.aktifCari.basket = yeniBasket;
          }
        }

        // Bildirim (best-effort)
        try {
          const first = Array.isArray(response) && response.length ? response[0] : {};
          const bildirimObje = {
            tip: 1,
            alias: "Sipariş",
            renk: "success",
            link: "siparis",
            seri: first.seri,
            sira: first.sira,
            odeme: paymentOrderNo ? String(paymentOrderNo) : "Açık Hesap",
            kid: hesap.kid,
            baslik: cari.unvan,
            ckod: cari.kod,
            names: hesap.kad
          };
          await this.$request.post("crm/bildirim/add", bildirimObje);
        } catch (e) { }

        try {
          sessionStorage.setItem("siparis_result", JSON.stringify({
            createdAt: Date.now(),
            ok: true,
            paymentOrderNo: paymentOrderNo || "",
            response: response || [],
            errors: errors || [],
            okCount: normalized.okCount || 0,
            failCount: normalized.failCount || 0
          }));
          if (createdKey) sessionStorage.setItem(createdKey, "1");
        } catch (e) { }

        this.$store.setLoading([false, "Bekleyiniz"]);
        this.$router.replace({ path: "/siparis/sonuc" });
      } catch (err) {
        try {
          sessionStorage.setItem("siparis_result", JSON.stringify({
            createdAt: Date.now(),
            ok: false,
            paymentOrderNo: paymentOrderNo || "",
            error: (err && err.message) ? err.message : "Sipariş eklenemedi"
          }));
          if (createdKey) sessionStorage.setItem(createdKey, "1");
        } catch (e) { }
        this.$store.setLoading([false, "Bekleyiniz"]);
        this.$router.replace({ path: "/siparis/sonuc" });
      }
    },

    goSiparisList() {
      this.$router.push("/siparis/list");
    },
    goSepet() {
      this.$router.push("/cari/sepet");
    }
  }
};
</script>

<style scoped>
.payment-result-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f8fafc;
}
.result-card {
  width: 100%;
  max-width: 520px;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e5eaf1;
  box-shadow: 0 10px 24px rgba(15, 23, 42, .08);
  padding: 22px 22px;
  text-align: center;
}
.result-icon {
  width: 74px;
  height: 74px;
  border-radius: 18px;
  margin: 0 auto 10px;
  display: grid;
  place-items: center;
}
.result-icon.loading {
  background: #eff6ff;
  color: #2563eb;
}
.result-icon.loading span {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 3px solid rgba(37, 99, 235, .25);
  border-top-color: #2563eb;
  animation: spin 1s linear infinite;
}
.result-icon.pending {
  background: #fff7ed;
  color: #ea580c;
}
.result-icon.failed {
  background: #fef2f2;
  color: #b91c1c;
  font-weight: 800;
  font-size: 30px;
}
.result-desc {
  color: #64748b;
  margin: 8px 0 0;
}
.result-actions {
  margin-top: 14px;
  display: flex;
  gap: 10px;
  justify-content: center;
}
.btn {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 12px;
  padding: 10px 12px;
  font-weight: 700;
  cursor: pointer;
}
.btn.primary {
  border-color: #2563eb;
  background: #2563eb;
  color: #fff;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>



// WEBPACK FOOTER //
// src/views/siparis/tahsilat_sonuc.vue